export default __webpack_public_path__ + "static/media/dot_green.6ffb692c.svg";